import styled from '@emotion/styled'

import { Button } from '@/legacy/components/Button'
import { decodeURL } from '@/legacy/core/utils/dom/decodeURL'
import type { BlockButtonProps } from '@/legacy/models'

import { CONFIG } from '@/ui/shared/styles'

import Blog, { type BlogProps } from './Blog'

export interface ListBlogProps extends BlockButtonProps {
  items: BlogProps[]
  itemsPerRow?: number
}

const ListBlogStyles = styled.div<Pick<ListBlogProps, 'itemsPerRow'>>(({ itemsPerRow }) => ({
  '& .list-blog': {
    display: 'grid',
    gap: '1rem',
    '--columns': 1,
    gridTemplateColumns: `repeat(var(--columns), 1fr)`,

    [CONFIG.media.md]: {
      '--columns': 2,
    },

    [CONFIG.media.lg]: {
      '--columns': itemsPerRow,
    },
  },

  '& .button': {
    display: 'block',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
}))

const ListBlog = ({
  itemsPerRow,
  items,
  hasButton,
  button,
  buttonLabel,
  buttonType,
  buttonValue,
}: ListBlogProps) => {
  const buttonProps = {
    buttonLabel: buttonLabel || button?.label,
    buttonType: buttonType || button?.action?.type,
    buttonValue: buttonValue || button?.action?.value,
  }

  return (
    <ListBlogStyles itemsPerRow={itemsPerRow}>
      <div className="list-blog eu-sm-4">
        {items && items.map((item, index) => <Blog key={`lb_item_${index}`} {...item} />)}
      </div>
      {hasButton && buttonProps && (
        <Button
          action={buttonProps.buttonType}
          value={decodeURL(buttonProps.buttonValue)}
          size="lg"
          modifier="solid-invert"
          className="button"
        >
          {buttonProps.buttonLabel}
        </Button>
      )}
    </ListBlogStyles>
  )
}

export default ListBlog
